import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { AlertTriangle } from "lucide-react";

interface VersionRestrictedModalProps {
  isOpen: boolean;
  onClose: () => void;
  onGoToLatest: () => void;
  currentVersion?: number;
  latestVersion?: number;
}

export function VersionRestrictedModal({
  isOpen,
  onClose,
  onGoToLatest,
  currentVersion,
  latestVersion
}: VersionRestrictedModalProps) {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <div className="flex items-center gap-2">
            <AlertTriangle className="h-5 w-5 text-amber-500" />
            <DialogTitle>Comments Not Available</DialogTitle>
          </div>
          <DialogDescription className="space-y-3 pt-2">
            <p>
              Sorry, you can't add comments to older versions of this document.
            </p>
            {currentVersion && latestVersion && (
              <p className="text-sm text-muted-foreground">
                You're viewing version {currentVersion}, but the latest is version {latestVersion}.
              </p>
            )}
          </DialogDescription>
        </DialogHeader>
        <div className="flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2">
          <Button variant="outline" onClick={onClose} className="mt-2 sm:mt-0">
            Stay Here
          </Button>
          <Button onClick={onGoToLatest}>
            Go to Latest Version
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}